export default __webpack_public_path__ + "static/media/masailogo.ab93bfe1.svg";